import React, { useContext } from "react";
import clsx from "clsx";
import loadable from "@loadable/component";
import WebProfileContext from "@WebProfileContext";
import useLocals from "@micado-digital/react-ui/hooks/useLocals";
import localDE from "@localDE";
import localEN from "@localEN";

import styles from "./Address.styles";

const Typography = loadable(() => import("@material-ui/core/Typography"));

const Address = ({ lang }) => {
	const css = styles();
	const [profileData] = useContext(WebProfileContext);
	const { mail, phone } = profileData;

	const l = useLocals({
		lang: lang,
		res: {
			de: localDE,
			en: localEN
		}
	});

	return (
		<div className={clsx(css.address, "mco-view-component-footer-address")}>
			<Typography className={css.title} component="p" variant="caption">
				{l("footer.contact")}
			</Typography>
			<div className={clsx(css.content, "mco-view-component-footer-address__content")}>
				<p>{profileData?.name}</p>
				<p>
					{profileData?.street}, {profileData?.zip} {profileData?.city}
				</p>
				{phone && (
					<Typography className={css.phone} component="p" variant="body2">
						Tel. <a href={"tel:" + phone?.replace(/ /g, "")}>{phone}</a>
					</Typography>
				)}
				{mail && (
					<Typography className={css.mail} component="p" variant="body2">
						<a href={"mailto:" + mail}>{mail}</a>
					</Typography>
				)}
			</div>
		</div>
	);
};

export default Address;
